import { Link, useSearchParams } from "react-router-dom";
import Shield2 from "../../../assets/aftersalesservice_icons/shield2.svg";
import HelpCenter from "../../../assets/aftersalesservice_icons/help_center.svg";
import PointRight from "../../../assets/aftersalesservice_icons/pointright_icon.svg";
import Policy from "../../../assets/aftersalesservice_icons/policy.svg";
import UserManual from "../../../assets/aftersalesservice_icons/user_manual.svg";
import ErrorCode from "../../../assets/aftersalesservice_icons/error_code.svg";
import FallbackImg from "../../../components/FallbackImg";
import { useLanguage } from "../LanguageContext";
import PreviewLayout from "./PreviewLayout";

const Preview = () => {
  const { trans } = useLanguage();
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get("item_id");

  return (
    <PreviewLayout>
      <div className="as-menu-center-content" id="menu_center_modal">
        <div className="as-sub-container">
          <div style={{ padding: "0 31.97px" }}>
            <div className="as-welcome-box">
              <div className="as-welcome-box-inner">
                <FallbackImg src={Shield2} alt="shield2" />
                <div className="as-welcome-box-text">
                  <p>{trans.welcome}</p>
                  <p>{trans.welcome_sub}</p>
                </div>
              </div>
            </div>

            {/* Help Center */}
            <div className="as-section-title as-orange">
              <FallbackImg src={HelpCenter} alt="helpcenter" />
              {trans.help_center}
            </div>
            <div className="as-menu-center-card">
              <Link
                to={`/aftersalesservice/previewwarrantypolicy?item_id=${itemId}`}
              >
                <div className="as-item" id="warranty_policy_btn">
                  <div className="as-left">
                    <FallbackImg src={Policy} alt="policy" />
                    <span>{trans.warr_policy}</span>
                  </div>
                  <FallbackImg src={PointRight} alt="pointright" />
                </div>
              </Link>

              <Link
                to={`/aftersalesservice/previewusermanual?item_id=${itemId}`}
              >
                <div className="as-item" id="user_manual_btn">
                  <div className="as-left">
                    <FallbackImg src={UserManual} alt="usermanual" />
                    <span>{trans.user_manual}</span>
                  </div>
                  <FallbackImg src={PointRight} alt="pointright" />
                </div>
              </Link>

              <Link
                to={`/aftersalesservice/previewerrorcode?item_id=${itemId}`}
              >
                <div className="as-item" id="error_code_btn">
                  <div className="as-left">
                    <FallbackImg src={ErrorCode} alt="errorcode" />
                    <span>{trans.error_code_guide}</span>
                  </div>
                  <FallbackImg src={PointRight} alt="pointright" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PreviewLayout>
  );
};

export default Preview;
